import { useState, useEffect } from 'react';
import butterflyApi from '../ButterflyApi';
import JSONPretty from 'react-json-pretty';

const ImageUpdate = () => {
  const [data, setData] = useState()

  const load = async () => {
    const result = await butterflyApi.getImageUpdateTasks()
    setData(result)
  }

  useEffect(() => {
    load();
  }, [])

  return <div className="px-4 mt-12">
    <div className="mb-4">
      <a href="/manage" className="text-blue-600 underline">Manage</a>
    </div>
    {
      data && <div className='text-xs'>
        <JSONPretty id="json-pretty" data={data}></JSONPretty>
      </div>
    }
  </div>
}

export default ImageUpdate
